import React from 'react';
import { connect } from 'react-redux';

import * as PostActions from "../../data/posts/PostActions";

import Post from './Post';

const mapStateToProps = (state, ownProps) => ({
    media: state.media // @todo ... maybe only grab the media for this Post..?
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onDelete: () => dispatch(PostActions.removePost(ownProps.post.id)),
    onShare: () => dispatch(PostActions.sharePost(ownProps.post.id)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Post);
